export const urlBuilder = (lang:string,pathTo:string)=>{
    let url = '';
    url = window.location.origin+'/'+lang+pathTo;
    return url;
}